"use client"

import { usePixelInjectionPermissionSisal } from "@/hooks/use-pixel-injection-permission"
import Script from "next/script"

export function QuantcastAllPagesPixelScriptSisal() {
  const canInjectPixels = usePixelInjectionPermissionSisal()

  if (!canInjectPixels) return null

  return (
    <Script id="quantcast-all-pages-pixel-sisal" type="text/javascript">
      {`
        window._qevents = window._qevents || []
        ;(function () {
          var elem = document.createElement("script")
          elem.src =
            (document.location.protocol == "https:" ? "https://secure" : "http://edge") +
            ".quantserve.com/quant.js"
          elem.async = true
          elem.type = "text/javascript"
          var scpt = document.getElementsByTagName("script")[0]
          scpt.parentNode.insertBefore(elem, scpt)
        })()

        window._qevents.push({
          qacct: "p-nv77kWD4K6vBa",
          labels: "_fp.event.PageView",
        })
      `}
    </Script>
  )
}
